import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApplicationMode } from '@core/interfaces/application';
import { NotFoundCause } from '@core/interfaces/not-found';
import { HubAuthService } from '@core/services/hub-auth/hub-auth.service';
import { HubRouterHelperService } from '@core/services/hub-router-helper/hub-router-helper.service';
import { SetApplicationMode } from '@core/store/application/application.actions';
import { AppState } from '@core/store/application/application.state';
import { NavbarState } from '@core/store/navbar/navbar.state';
import { select, Store } from '@ngxs/store';
import { HubButtonComponent } from '@shared/atoms/hub-button/hub-button.component';
import { MainNavbarComponent } from '@shared/features/hub-main-navbar/main-navbar.component';
import { MainHeaderComponent } from '../hub-main-header/main-header.component';

@Component({
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MainNavbarComponent, HubButtonComponent, MainHeaderComponent],
})
export class PageNotFoundComponent implements OnInit {
  private readonly store = inject(Store);
  private readonly route = inject(ActivatedRoute);
  private readonly hubAuthService = inject(HubAuthService);
  private readonly hubRouterHelperService = inject(HubRouterHelperService);

  closed = select(NavbarState.closed);
  mode = select(AppState.mode);

  notFoundCause = NotFoundCause;

  cause = '';

  ngOnInit(): void {
    if (this.hubRouterHelperService.currentUrl() === '/404') {
      this.store.dispatch(new SetApplicationMode(ApplicationMode.hub));
    }
    const { cause } = this.route.snapshot.queryParams;
    this.cause = Object.values(NotFoundCause).includes(cause) ? cause : NotFoundCause.PAGE;
  }

  logout(): void {
    this.hubAuthService.logout();
  }
}
